// extracted by mini-css-extract-plugin
export default {"card":"Usuario_card__YDJ9g","botao":"Usuario_botao__YpSv0"};